import { FC, useCallback, useState } from 'react'
import styles from './header.module.scss'
import HeaderTop from './HeaderTop'
import HeaderBottom from './HeaderBottom'
import classNames from '@/utils/helpers/class-names.helper'

type HeaderProps = {}

const Header: FC<HeaderProps> = ({}) => {
  const [visibleBurgerMenu, setVisibleBurgerMenu] = useState<boolean>(false)

  const handleOpenBurgerMenu = useCallback(() => {
    setVisibleBurgerMenu(true)
  }, [])

  const handleCloseBurgerMenu = useCallback(() => {
    setVisibleBurgerMenu(false)
  }, [])

  return (
    <header className={styles.header}>
      <div className={classNames('overlay', visibleBurgerMenu && '_visible')}></div>
      <HeaderTop onOpenBurgerMenu={handleOpenBurgerMenu} />
      <HeaderBottom
        onCloseBurgerMenu={handleCloseBurgerMenu}
        visibleBurgerMenu={visibleBurgerMenu}
      />
    </header>
  )
}

export default Header
